export const EMPLOYEE_FAIR_PAY_MENU_ITEMS = [
  { title: "Pay Plans", count: null },
  { title: "Bonuses", count: null },
  { title: "Eligibility", count: null },
];

export const EMPLOYEE_FAIR_PAY_TAB = {
  PAY_PLANS: 0,
  BONUSES: 1,
  ELIGIBILITY: 2,
};
